import { Box, Button, Typography } from "@mui/material";
import { useNotification } from "../../contexts/NotificationContext";

export default function FileChecksumValue({ file }) {
  const { showNotification } = useNotification();
  if (file.checksum_status !== "ready" || !file.sha256) return null;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(file.sha256);
      showNotification("SHA-256 checksum copied", "success");
    } catch {
      showNotification("Could not copy checksum", "error");
    }
  };
  return (
    <Box component="span" sx={{ display: "block", mt: 1, minWidth: 0 }}>
      <Typography component="span" variant="caption" color="text.secondary">
        SHA-256 Hash
      </Typography>
      <Typography
        component="code"
        variant="caption"
        sx={{
          display: "block",
          fontFamily: "monospace",
          overflowWrap: "anywhere",
          userSelect: "all",
        }}
      >
        {file.sha256}
      </Typography>
      <Button size="small" onClick={copy}>
        Copy SHA-256 Hash
      </Button>
    </Box>
  );
}
